/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonRelayerChannelListRequest = {
    clientId?: string;
    period?: BabylonRelayerChannelListRequest.period;
    sortField?: BabylonRelayerChannelListRequest.sortField;
    sortDirection?: BabylonRelayerChannelListRequest.sortDirection;
    term?: string;
    page?: number;
    size?: number;
};

export namespace BabylonRelayerChannelListRequest {

    export enum period {
        D7 = 'D7',
        D30 = 'D30',
        D90 = 'D90',
    }

    export enum sortField {
        RECEIVE_TRX_COUNT = 'RECEIVE_TRX_COUNT',
        SEND_TRX_COUNT = 'SEND_TRX_COUNT',
        ASSET_COUNT = 'ASSET_COUNT',
        OPERATING_TIME = 'OPERATING_TIME',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

